export const getPrimeOptionsFormatArr = (optionsObjStateValue) => {
  const optionsObjStateValueKeysArr = Object.keys(optionsObjStateValue);

  const primeOptionsFormatArr = optionsObjStateValueKeysArr.map(
    (groupObjKey) => optionsObjStateValue[groupObjKey]
  );

  return primeOptionsFormatArr;
};
